import React, { useEffect, useState } from "react";
import { getSubstituteSkuList } from "../../../services/sku";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import SkusSlider from "../../../components/SkusSlider/SkusSlider";

const SubstituteSkuList = ({ productId: propProductId }) => {
  const { productId: urlProductId } = useParams();
  const productId = propProductId || urlProductId;
  const selectedMechanic = useSelector((state) => state.mechanic);

  const [substituteSkus, setSubstituteSkus] = useState([]);
  const [isSkusLoading, setIsSkusLoading] = useState(false);

  useEffect(() => {
    const fetchSubstituteSkuList = async () => {
      setIsSkusLoading(true);
      try {
        const { data } = await getSubstituteSkuList(
          productId,
          selectedMechanic?.id
        );

        setSubstituteSkus(data.skuList);
      } catch (error) {
        console.error(error);
      }
      setIsSkusLoading(false);
    };

    if (!isNaN(parseInt(productId)) && selectedMechanic?.id) {
      fetchSubstituteSkuList();
    }
  }, [productId, selectedMechanic?.id]);

  return (
    <SkusSlider
      className="xs:mx-14 mb-16"
      isLoading={isSkusLoading}
      title="منتجات بديلة"
      skus={substituteSkus.map((sku) => ({
        ...sku,
        imageList: [{ imageUrl: sku.imageUrl }],
        isValid: !!sku.quantity,
      }))}
    />
  );
};

export default SubstituteSkuList;
